import { siteInfo } from '@/mocks/home';

const stats = [
  { value: '12,800+', label: '独家爆料' },
  { value: '360万+', label: '月活读者' },
  { value: '7×24h', label: '全天候更新' },
];

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20studio%20backdrop%20with%20deep%20crimson%20velvet%20curtains%20and%20ambient%20warm%20golden%20theatrical%20lighting%2C%20multiple%20glowing%20screens%20displaying%20breaking%20celebrity%20headlines%20in%20a%20dark%20sophisticated%20atmosphere%2C%20cinematic%20composition%20with%20rich%20contrasts%20and%20dramatic%20shadows%2C%20editorial%20photojournalism%20aesthetic%2C%20professional%20broadcast%20newsroom%20vibe%20with%20subtle%20digital%20interface%20elements%2C%20high%20contrast%20dramatic%20lighting%20with%20red%20and%20gold%20highlights&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="51黑料网 - 娱乐资讯深度爆料平台主视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-500/90 text-white text-xs font-semibold tracking-wide mb-4 md:mb-5">
              最新地址已更新 · 安全直达
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              {siteInfo.name}
              <br />
              <span className="text-accent-300">娱乐圈深度爆料第一入口</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-white/70 mt-3 mb-5 md:mb-6 italic">
              {siteInfo.slogan}
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-white/80 leading-relaxed">
                51黑料网是国内领先的娱乐资讯深度爆料平台，汇集全网最新明星八卦、影视内幕、综艺真相与资本暗战。
                依托覆盖全娱乐产业的独立消息源网络，我们每日更新独家黑料，以最快速度为你揭示镜头背后的真实故事。
                当前热门焦点涵盖顶流塌房追踪、综艺剪辑造假揭秘及娱乐圈资本运作深层解析——所有内容安全匿名访问，无需注册即可直达。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6 md:mt-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-300">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/60 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7 md:mt-8">
              <button
                onClick={() => handleScroll('#updates')}
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                查看最新黑料
              </button>
              <button
                onClick={() => handleScroll('#carousel')}
                className="w-full sm:w-auto px-7 py-3 border border-white/30 hover:border-white/60 text-white font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览焦点专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=A%20theatrical%20scene%20with%20a%20single%20powerful%20spotlight%20illuminating%20a%20dark%20stage%2C%20a%20mysterious%20velvet%20curtain%20partially%20drawn%20revealing%20a%20glowing%20screen%20with%20breaking%20news%20text%2C%20dramatic%20red%20and%20gold%20lighting%2C%20entertainment%20gossip%20portal%20aesthetic%2C%20cinematic%20composition%2C%20editorial%20dramatic%20photography%2C%20rich%20dark%20tones%20with%20warm%20highlights&width=800&height=700&seq=hero-side&orientation=landscape"
                alt="51黑料网核心入口主视觉 - 娱乐圈爆料专题聚合"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                  <span className="text-white/90 text-xs md:text-sm font-medium">实时更新中 · 最新内容已同步</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}